import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './task-simple.types';

export const taskSimpleSelectors = {
  ...generateResourceSelectors<types.ITaskSimple>((state) => state.resource.taskSimple),
};
